<section class="rename-group-dialog" aria-label="Rename group chat popup">
  <header class="rename-group-dialog__header" mat-dialog-title>
    <h2>Rename Group</h2>
    <button type="button" mat-icon-button class="icon-close" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="rename-group-dialog__content">
    <p class="rename-group-dialog__description">Choose a clear name so everyone can find this chat quickly.</p>

    <form class="rename-group-dialog__form" [formGroup]="form" novalidate>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Group name</mat-label>
        <input
          matInput
          formControlName="channel_friendly_name"
          placeholder="Enter group name"
          maxlength="80"
        />
        @if (hasControlError('required')) {
          <mat-error>Group name is required.</mat-error>
        }
        @if (hasControlError('maxlength')) {
          <mat-error>Group name must be 80 characters or less.</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <footer class="rename-group-dialog__actions" mat-dialog-actions align="end">
    <button type="button" mat-stroked-button color="primary" (click)="close()">Cancel</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">Save</button>
  </footer>
</section>
